import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 768" {...props}>
      <path
        fill="currentColor"
        d="M441.591 619.195c-12.595 12.592-12.595 33.014 0 45.603 12.592 12.599 33.014 12.599 45.61 0l280.8-280.797-280.8-280.798c-12.595-12.598-33.018-12.598-45.61 0-12.595 12.591-12.595 33.011 0 45.603l203.194 203.199h-612.536c-17.811 0-32.249 14.438-32.249 32.249s14.438 32.249 32.249 32.249h612.033l-202.692 202.692z"
      ></path>
    </svg>
  );
}

export default Icon;
